// extracted by mini-css-extract-plugin
var _1 = "content__n5JfN";
var _2 = "is-active__PTY0a";
var _3 = "radio-tab__sW5Gf";
export { _1 as "content", _2 as "is-active", _3 as "radio-tab" }
